import React from "react";
import Skeleton from "react-loading-skeleton";

const ProjectSkeleton = ({ count = 4 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div className="card-item pt-0" key={index}>
          <div className="card-thumb pb-0" style={{overflow:"hidden"}}>
            <Skeleton width="100%" height="100%" />
          </div>

          <div className="card-info">
            <div className="card-info-item">
              <Skeleton width="10rem" height="1rem" />
            </div>

            <Skeleton width="10rem" height="1rem" />
            <div class="owner-detail">
              <Skeleton circle="50%" width="1.5rem" height="1.5rem" />
              <Skeleton width="5rem" height="1rem" />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ProjectSkeleton;
